import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H2 } from 'components/common/Text/Text'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { Separator } from 'components/common/Separator/Separator'
import { LazyDiv } from 'components/common/LazyHtml'

const BOTFeaturedArticles = ({ items, title, contentBlock }) =>
  Boolean(contentBlock) &&
    <Wrapper data-at-services-featuredarticles>
      <Separator />
      <ArticlesWrapper>
        <Title headline centered>{ title }</Title>
        <LazyDiv data-html-block content={ contentBlock } />
      </ArticlesWrapper>
    </Wrapper>

BOTFeaturedArticles.propTypes = {
  contentBlock: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string
}

export default BOTFeaturedArticles

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '0 16px', '0 16px')}
`

const ArticlesWrapper = styled.div`
  position: relative;
  text-align: center;
  ${Mixin.responsive('padding', '50px 0', '40px 0')}
`

const Title = styled(H2)`
  ${Media.mobile`
    font-size: 20px;
    line-height: 30px;
  `}
  ${Mixin.responsive('margin', '0 0 32px', '0 0 30px')}
`
